import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

const RoadShipment = ({ shipmentData }) => {
  const { shipmentEvents, ...rest } = shipmentData;

  const renderDetails = () => {
    return (
      <Box mt={4}>
        <Typography variant="h5" gutterBottom>Shipment Details</Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Field</strong></TableCell>
                <TableCell><strong>Value</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(rest).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell>{key}</TableCell>
                  <TableCell>{JSON.stringify(value)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  const renderEvents = () => {
    if (!shipmentEvents || shipmentEvents.length === 0) return null;

    // return (
    //   <Box mt={4}>
    //     <Typography variant="h6" gutterBottom>Shipment Events</Typography>
    //     <TableContainer component={Paper}>
    //       <Table>
    //         <TableHead>
    //           <TableRow>
    //             <TableCell><strong>Name</strong></TableCell>
    //             <TableCell><strong>Actual Time</strong></TableCell>
    //             <TableCell><strong>Location</strong></TableCell>
    //           </TableRow>
    //         </TableHead>
    //         <TableBody>
    //           {shipmentEvents.map((event, index) => (
    //             <TableRow key={index}>
    //               <TableCell>{event.name}</TableCell>
    //               <TableCell>{event.actualTime || 'N/A'}</TableCell>
    //               <TableCell>{event.location}</TableCell>
    //             </TableRow>
    //           ))}
    //         </TableBody>
    //       </Table>
    //     </TableContainer>
    //   </Box>
    // );
  };

  return (
    <>
      {renderDetails()}
      {renderEvents()}
    </>
  );
};

export default RoadShipment;